import React, { Component } from 'react';

class AppSpinner extends Component {

  render() {

    return (
      <div className="loader center"></div>
    );
  }
}

export default AppSpinner;